<template>
  <div class="gonggao">
	<ul>
		<li class="gonggao_list">
			<h2>{{ notice.title }}</h2>
			<p class="gonggao_time">{{ notice.updated_at }}</p>
			<!-- <div class="gonggao_img" :style="{'backgroundImage':'url('+notice.img+')'} "></div> -->
			<div class="" style="position: relative;">
				<div style="position: relative;" v-html="notice.content"></div>
			</div>
		</li>
	</ul>
  </div>
</template>
<script>
export default {
	metaInfo: {
		title: "拍界——唤醒您的沉睡资产",
		meta: [{
			name: "keywords",
			content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}, {
			name: "description",
			content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}]
	},
	data() {
		return {
			notice: {},
			id: this.$route.query.id
		}
	},
	created() {
		// 请求页面数据
		this.axios.get(this.$global.apiUrl.notices_show, {
			params: {
				id: this.id
			}
		})
		.then((response) => {
			if (response.data.error.code == 0) {
				this.notice = response.data.notice;
			}
		})
		.catch(() => {})
	},
}
</script>